import React, { useEffect, useRef } from "react";
import { Button } from "antd";
import classNames from "classnames";
import "./flights-horizontal-date-strip.scss";
import dayjs from "dayjs";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

export default function FlightsHorizontalDateStrip({
  flightSearchParams,
  quickCalendar,
  onSelected,
}) {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);

  useEffect(() => {
    const idx = quickCalendar.items.findIndex(
      (item) => item.date === quickCalendar.selected
    );

    if (idx >= 0 && containerRef.current && itemRefs.current[idx]) {
      const container = containerRef.current;
      const item = itemRefs.current[idx];

      const containerRect = container.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      const offset =
        itemRect.left -
        containerRect.left +
        itemRect.width / 2 -
        containerRect.width / 2;

      container.scrollBy({
        left: offset,
        behavior: "smooth",
      });
    }
  }, [quickCalendar.selected, quickCalendar.items]);

  function formatTimelineDate(dateStr) {
    return dayjs(dateStr).format("ddd, D MMM");
  }

  function formatTimelineDateRange(dateStr1, dateStr2) {
    return `${dayjs(dateStr1).format("D MMM")} - ${dayjs(dateStr2).format("D MMM")}`;
  }

  const scrollByPage = (direction) => {
    const container = containerRef.current;
    if (!container) return;
  
    const scrollAmount = container.clientWidth;
  
    container.scrollBy({
      left: direction === "right" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  };

  function addDateOffsetSafe(start1, end1, baseDate) {
    try {
        const d1 = new Date(start1 + 'T00:00:00');
        const d2 = new Date(end1 + 'T00:00:00');
        const base = new Date(baseDate + 'T00:00:00');
      
        const diffDays = Math.round((d2 - d1) / (1000 * 60 * 60 * 24)) + 1;
      
        base.setDate(base.getDate() + diffDays);
      
        return base.toISOString().slice(0, 10);
    } catch (err) {
        console.log({start1, end1, baseDate});
    }
  }

  return (
    <div className="horizontal-date-strip">
      <LeftOutlined
        className="nav-btn left"
        onClick={() => scrollByPage("left")}
      />
      <div className="date-list" ref={containerRef}>
        {quickCalendar.items.map((item, i) => {
          const isSelected = item.date === quickCalendar.selected;
          const endDate =
            flightSearchParams.journeyType === "rt"
              ? addDateOffsetSafe(
                  flightSearchParams.journeyRoutes[0].departDate,
                  flightSearchParams.journeyRoutes[1].departDate,
                  item.date
                )
              : undefined;

          return (
            <React.Fragment key={item.date}>
              <div
                ref={(el) => (itemRefs.current[i] = el)}
                className={classNames("date-item", { selected: isSelected })}
                onClick={() => {
                  if (flightSearchParams.journeyType === "rt") {
                    onSelected([item.date, endDate]);
                  } else if (flightSearchParams.journeyType === "ow") {
                    onSelected([item.date]);
                  }
                }}
              >
                <div className="date-text">
                  {flightSearchParams.journeyType === "rt"
                    ? formatTimelineDateRange(item.date, endDate)
                    : formatTimelineDate(item.date)}
                </div>
                <div className="price-text">
                  {item.displayLowestPrice || "View"}
                </div>
              </div>

              {i !== quickCalendar.items.length - 1 && (
                <div className="divider" />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <RightOutlined
        className="nav-btn right"
        onClick={() => scrollByPage("right")}
      />
    </div>
  );
}
